import { Component, OnDestroy, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SimplebarAngularComponent } from 'simplebar-angular';
import {
  AlertService,
  AppConfigService,
  CalendarioService,
  CuestionariosService,
  GestionActCuestionarioService
} from 'src/app/core/services';
import {
  CuestionarioRespuesta,
  ItemResumenCuestionario,
  Plantilla,
  ValoracionCuestionario,
  Respuesta,
  LocaleTexto
} from '../../../../core/models';

declare var $: any;

/**
 * Componente para el registro de un cuestionario.
 *
 * @author lreverendo
 * @author dvila
 * @author aarodriguezo
 *
 * @version 01.02.0450
 * @since 01.02.0000
 */
@Component({
  selector: 'app-registro-cuestionario',
  templateUrl: './registro-cuestionario.component.html',
  styleUrls: ['../../cuestionarios.component.css', './registro-cuestionario.component.css']
})
export class RegistroCuestionarioComponent implements OnDestroy {
  @ViewChild('preguntas') preguntas: SimplebarAngularComponent;
  public pagina = 0;
  public tipo: String;
  public titulo: LocaleTexto[];
  public items: ItemResumenCuestionario[] = [];
  public plantilla: Plantilla = new Plantilla();
  public valoraciones: ValoracionCuestionario[];
  public respuestas: {} = {};
  public disabled: Boolean = true;
  public esCuestionarioCondicional: Boolean = true;
  public ultimaPreguntaContestada: Boolean = false;

  public avisoCerrar: Boolean = false;

  public desplazamientoMedioTramo: number;
  public medioTramo: {
    primero: number;
    ultimo: number;
  };

  private sub: Subscription;

  constructor(
    private alertService: AlertService,
    private calendarioService: CalendarioService,
    private cuestionariosService: CuestionariosService,
    private gestionActCuestionarioService: GestionActCuestionarioService,
    private translateService: TranslateService
  ) {
    // Subscripción en el evento registroCuestionario.
    this.sub = this.gestionActCuestionarioService.registroCuestionario.subscribe((data) => {
      this.pagina = 0;
      this.disabled = true;
      this.respuestas = {};
      this.avisoCerrar = false;
      this.tipo = data.tipoOntologia;
      this.titulo = data.titulo;
      this.plantilla = data.plantilla;
      this.valoraciones = data.valoraciones;
      this.items = [];
      this.esCuestionarioCondicional = data.formatoCuestionario && data.formatoCuestionario.toLowerCase() === 'condicional';


      const tam: number = window.innerWidth;
      this.calcularDesplazamientoMedio(tam);
      this.gestionarBurbujasMedio();

      $('#registro-cuestionario').modal({ backdrop: 'static', keyboard: false });

      if ($('#modal').hasClass('show')) {
        // Se abre el modal.
        $('#modal').modal('hide');
      }

      // Se abre el modal.
      $('#registro-cuestionario').modal('show');

      $('#registro-cuestionario').on('shown.bs.modal', function () {
        const instance = $(this);
        setTimeout(function () {
          const input = instance.closest('#registro-cuestionario').find('input')[0];
          if (input) {
            input.focus();
          }
        }, 180);
      });
    });
  }

  public ngOnDestroy(): void {
    // Baja a la subscripción.
    this.sub.unsubscribe();
  }

  public todasCompletas(): Boolean {
    const coincideItemsGuardadosConPreguntas: boolean = this.items.length === this.plantilla.preguntas.length;
    const todasCompletas = coincideItemsGuardadosConPreguntas || (this.ultimaPreguntaContestada && this.esCuestionarioCondicional);
    return todasCompletas;
  }

  public agregarRespuesta(idPregunta, idRespuesta): void {
    const indicePregunta = this.plantilla.preguntas.findIndex(p => p.id === idPregunta);
    if (indicePregunta === -1) {
      return;
    }
  
    const respuestaAnterior = this.respuestas[idPregunta];
  
    // Caso: cuestionario condicional y la pregunta ya tenía respuesta diferente
    if (this.esCuestionarioCondicional && respuestaAnterior !== undefined && respuestaAnterior !== idRespuesta) {
      this.respuestas[idPregunta] = idRespuesta;
  
      // Borrar todas las respuestas posteriores 
      for (let i = indicePregunta + 1; i < this.plantilla.preguntas.length; i++) {
        const idSiguiente = this.plantilla.preguntas[i].id;
        if (this.respuestas.hasOwnProperty(idSiguiente)) {
          delete this.respuestas[idSiguiente];
        }
      }
  
      // Limpiar el array items a partir de la posición siguiente (manteniendo el item actual)
      // Si items contiene elementos por índice de página, truncamos desde indicePregunta+1
      if (this.items && this.items.length > indicePregunta + 1) {
        this.items.splice(indicePregunta + 1);
      }
      this.ultimaPreguntaContestada = false;
    }
    else if (respuestaAnterior === undefined) {
      // Si no había respuesta antes (primera vez), simplemente se guarda
      this.respuestas[idPregunta] = idRespuesta;
    } else {
      // No es condicional o la respuesta es igual: 
      this.respuestas[idPregunta] = idRespuesta;
    }
  
    // Retardo de 200 msegundos
    setTimeout(() => {
      this.asociarPregunta(idPregunta);
    }, 200);
  }
  
  

  public asociarPregunta(idPregunta): void {
    let nombrePregunta: String;
    let descRespuesta: String = '';
    let respuestas: Respuesta[];
    const pregunta = this.plantilla.preguntas[this.pagina];

    switch (this.getCurrentIdioma()) {
      case 'gl':
        nombrePregunta = pregunta.nombre_gl;
        respuestas = pregunta.respuestasAsociadas;
        if (respuestas != null) {
          for (const respuesta of respuestas) {
            if (respuesta.id === this.respuestas[idPregunta]) {
              descRespuesta = respuesta.descripcion_gl;
            }
          }
        }
        break;
      case 'en':
        nombrePregunta = pregunta.nombre_en ? pregunta.nombre_en : pregunta.nombre_gl;
        respuestas = pregunta.respuestasAsociadas;
        if (respuestas != null) {
          for (const respuesta of respuestas) {
            if (respuesta.id === this.respuestas[idPregunta]) {
              descRespuesta = respuesta.descripcion_en ? respuesta.descripcion_en : respuesta.descripcion_gl;
            }
          }
        }
        break;
      default:
        nombrePregunta = pregunta.nombre;
        respuestas = pregunta.respuestasAsociadas;
        if (respuestas != null) {
          for (const respuesta of respuestas) {
            if (respuesta.id === this.respuestas[idPregunta]) {
              descRespuesta = respuesta.descripcion;
            }
          }
        }
        break;
    }

    if (descRespuesta === '') {
      // idRespuesta es la propia respuesta
      descRespuesta = this.respuestas[idPregunta];
    }


    this.items[this.pagina] = {
      pregunta: {
        id: idPregunta,
        nombre: nombrePregunta
      },
      respuesta: {
        id: this.respuestas[idPregunta],
        descripcion: descRespuesta
      }
    };

    
    this.irPaginaSiguiente(idPregunta);
  }

  public irPaginaSiguiente(idPregunta): void {
    const paginaSiguiente = this.pagina + 1;
  
    if (this.esCuestionarioCondicional && idPregunta != null) {    
      const preguntaActual = this.plantilla.preguntas[this.pagina];
      const idRespuesta = this.respuestas[idPregunta];
  
      let idSiguientePregunta = -1;
  
      // Obtener el id de la siguiente pregunta de la respuesta seleccionada
      if (preguntaActual.respuestasAsociadas != null && preguntaActual.respuestasAsociadas.length > 0) {
        const respuestaSeleccionada = preguntaActual.respuestasAsociadas.find(
          (resp) => resp.id === idRespuesta
        );
        if (respuestaSeleccionada) {
          idSiguientePregunta = respuestaSeleccionada.idPreguntaSiguiente;
        }
      }
      else if (preguntaActual.idPreguntaSiguiente != null) {
        // Si no hay respuestas asociadas, pero hay un idPreguntaSiguiente directo
        idSiguientePregunta = preguntaActual.idPreguntaSiguiente;
      }
  
      // Determinar la página (índice) a la que ir
      let nuevaPagina = -1;
      if (idSiguientePregunta > 0) {
        
        // Es una pregunta. Encontrar el índice (pagina) de la pregunta con ese ID.
        // Si no se encuentra el ID, findIndex devuelve -1.
        nuevaPagina = this.plantilla.preguntas.findIndex((p) => p.id === idSiguientePregunta);
  
        // Si no se encuentra la pregunta (error de plantilla) o es la última, se va al resumen
        if (nuevaPagina === -1) {
          nuevaPagina = this.plantilla.preguntas.length; 
        }
      } else {
        // idSiguientePregunta es 0 o -1.
        // El flujo condicional ha terminado, se va al resumen.
        nuevaPagina = this.plantilla.preguntas.length;
        this.ultimaPreguntaContestada = true;
      }
  
      if (nuevaPagina >= 0) {
        this.irPagina(nuevaPagina);
      }
      
    } else {
      // Cuestionarios secuenciales
      if (this.pagina < this.plantilla.preguntas.length) {
        this.irPagina(paginaSiguiente);
      }
    }
  }

  public irPaginaAnterior(): void {
    if (this.pagina > 0) {
      let paginaAnterior = this.pagina - 1;

      if (this.esCuestionarioCondicional) {
        if (this.plantilla.preguntas[this.pagina].idPreguntaPadre != null) {
          paginaAnterior = this.plantilla.preguntas[this.pagina].idPreguntaPadre - 1;
        }
      }

      this.irPagina(paginaAnterior);
    }
  }

  


  public cerrar(): void {
    // Se muestra un aviso antes de cerrar.
    if (this.avisoCerrar) {
      // Si el aviso ya estaba abierto, se cierra el modal.
      $('#registro-cuestionario').modal('hide');
    }
    this.avisoCerrar = true;
  }

  public enviarCuestionario(): void {
    const body: CuestionarioRespuesta = {
      origen: AppConfigService.origenDatos,
      respuestas: this.respuestas,
      plantilla: this.plantilla,
      codigoCuestionario: this.tipo,
      titulo: this.titulo,
      valoraciones: this.valoraciones
    };
    this.cuestionariosService.enviarCuestionario(body).subscribe(
      () => {
        // Se cierra el modal.
        this.ultimaPreguntaContestada = false;
        $('#registro-cuestionario').modal('hide');
        this.calendarioService.actualizarCalendario.emit();
        this.alertService.lanzarExito(this.translateService.instant('CUESTIONARIOS.NOTIFICACION.SUCCESS'));
      },
      (error) => {
        // Se cierra el modal.
        this.ultimaPreguntaContestada = false;
        $('#registro-cuestionario').modal('hide');
        this.alertService.lanzarError(error.status);

      }
    );
  }

  public irPagina(pagina: number): void {
    this.pagina = pagina;
    if (this.todasCompletas() && this.pagina === this.plantilla.preguntas.length) {
      this.disabled = false;
    }
    this.gestionarBurbujasMedio();
    if (this.preguntas) {
      this.preguntas.SimpleBar.getScrollElement().scrollTop = 0;
    }
  }

  public irPregunta(idPregunta: number): void {

    if (this.esCuestionarioCondicional && this.items[idPregunta - 1]){
      const posicionPregunta = idPregunta - 1;
      if (this.items[posicionPregunta].pregunta && this.items[posicionPregunta].pregunta.id != null && this.items[posicionPregunta].pregunta.id === idPregunta){ 
        this.irPagina(posicionPregunta);
      
    }
  }

  else if (!this.esCuestionarioCondicional) {
    const index = this.items.findIndex(item => item.pregunta.id === idPregunta);
    if (index > -1) {
      this.irPagina(index);
    } 
  }
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event): void {
    const tam: number = event.target.innerWidth;
    this.calcularDesplazamientoMedio(tam);
    this.gestionarBurbujasMedio();
  }

  private calcularDesplazamientoMedio(tamPantalla: number): void {
    // El desplazamientoMedioTramo se refiere al número de burbujas por atrás y por delante del mínimo, que es 3.
    const numPreguntas: number = this.plantilla.preguntas.length;
    this.desplazamientoMedioTramo = (numPreguntas - 3) / 2;

    if (tamPantalla < 418) {
      if (numPreguntas > 3) {
        this.desplazamientoMedioTramo = 0;
      }
    } else if (tamPantalla < 576) {
      if (numPreguntas > 5) {
        this.desplazamientoMedioTramo = 1;
      }
    } else if (tamPantalla < 768) {
      if (numPreguntas > 7) {
        this.desplazamientoMedioTramo = 2;
      }
    } else if (tamPantalla < 992) {
      if (numPreguntas > 9) {
        this.desplazamientoMedioTramo = 3;
      }
    } else {
      if (numPreguntas > 13) {
        this.desplazamientoMedioTramo = 5;
      }
    }
  }

  private gestionarBurbujasMedio(): void {
    if (!this.esCuestionarioCondicional) {
      const numPreguntas: number = this.plantilla.preguntas.length - 1;

      const atras = Math.round(this.desplazamientoMedioTramo);
      const delante = Math.floor(this.desplazamientoMedioTramo);

      let primero = this.pagina - atras;
      let ultimo = this.pagina + delante;

      let auxPrimero = primero;
      let auxUltimo = ultimo;

      if (primero < 1) {
        auxUltimo = ultimo + -primero + 1;
        auxPrimero = 1;
      }

      if (ultimo > numPreguntas - 1) {
        auxPrimero = primero - (ultimo - numPreguntas) - 1;
        auxUltimo = numPreguntas - 1;
      }

      primero = auxPrimero;
      ultimo = auxUltimo;

      // Primero y ultimo del tramo teniendo en cuenta el deplazamiento.
      this.medioTramo = {
        primero: primero,
        ultimo: ultimo
      };

      setTimeout(function () {
        $('#respuestaNum').trigger('focus');
        $('#respuestaTexto').trigger('focus');
      }, 100);
    }
  }

  public getCurrentIdioma(): string {
    // Se recupera el idioma actual.
    return this.translateService.currentLang;
  }

  public bloquearCaracteres(event: KeyboardEvent) {
    const caracteresProhibidos = ["'", '"'];
    if (caracteresProhibidos.includes(event.key)) {
      event.preventDefault(); // bloquea la tecla
    }
  }
}
